"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamPartReconnect = void 0;
const utils_1 = require("@streamr/utils");
const PeerDescriptorStoreManager_1 = require("./PeerDescriptorStoreManager");
const DEFAULT_RECONNECT_INTERVAL = 30 * 1000;
class StreamPartReconnect {
    abortController;
    discoveryLayerNode;
    peerDescriptorStoreManager;
    constructor(discoveryLayerNode, peerDescriptorStoreManager) {
        this.discoveryLayerNode = discoveryLayerNode;
        this.peerDescriptorStoreManager = peerDescriptorStoreManager;
    }
    async reconnect(timeout = DEFAULT_RECONNECT_INTERVAL) {
        this.abortController = new AbortController();
        await (0, utils_1.scheduleAtInterval)(async () => {
            const entryPoints = await this.peerDescriptorStoreManager.fetchNodes();
            await this.discoveryLayerNode.joinDht(entryPoints);
            // Is is necessary to store the node as an entry point here?
            if (!this.peerDescriptorStoreManager.isLocalNodeStored() && entryPoints.length < PeerDescriptorStoreManager_1.MAX_NODE_COUNT) {
                await this.peerDescriptorStoreManager.storeAndKeepLocalNode();
            }
            if (this.discoveryLayerNode.getNeighborCount() > 0) {
                this.abortController.abort();
            }
        }, timeout, true, this.abortController.signal);
    }
    isRunning() {
        return this.abortController ? !this.abortController.signal.aborted : false;
    }
    destroy() {
        this.abortController?.abort();
    }
}
exports.StreamPartReconnect = StreamPartReconnect;
//# sourceMappingURL=StreamPartReconnect.js.map